/* @flow */
import * as React from 'react';

import styles from './styles.module.scss';
import protonesUtils from '../../utils/protones';

import type { Person } from '../../types';

type Props = {
  people?: Person[],
  isExpanded?: boolean,
  emptyText: string,
  onToggleExpand?: () => mixed,
  onPersonClick?: (person: Person) => mixed,
};

class PeopleAggregation extends React.PureComponent<Props, void> {
  render() {
    const { emptyText, people, isExpanded, onPersonClick, onToggleExpand } = this.props;
    if (!people || people.length === 0) {
      return <div>{emptyText}</div>;
    } else if (people.length <= 2) {
      return (
        <div
          title={people.map(protonesUtils.getPersonLabel).join(', ')}
          className={styles.container}
        >
          {people.map((person, index) => {
            return (
              <div className={styles.ellipsisWrapper} key={`person-${person.id}-${index}`}>
                <span
                  className={onPersonClick ? styles.ellipsis : styles.ellipsisNotClickable}
                  onClick={onPersonClick ? () => onPersonClick(person) : undefined}
                >
                  {protonesUtils.getPersonLabel(person)}
                </span>
              </div>
            );
          })}
        </div>
      );
    } else {
      const [firstPerson, ...others] = people;
      return (
        <div
          title={people.map(protonesUtils.getPersonLabel).join(', ')}
          className={styles.container}
        >
          <div className={styles.ellipsisWrapper}>
            <span
              className={onPersonClick ? styles.ellipsis : styles.ellipsisNotClickable}
              onClick={onPersonClick ? () => onPersonClick(firstPerson) : undefined}
            >
              {protonesUtils.getPersonLabel(firstPerson)}
            </span>
          </div>
          <div className={styles.ellipsisWrapper}>
            <span
              className={styles.ellipsisOthers}
              // title={people.map(protonesUtils.getPersonLabel).join(', ')}
              onClick={onToggleExpand}
            >
              {onToggleExpand &&
                (isExpanded
                  ? `nascondi gli altri ${others.length} ...`
                  : `ed altri ${others.length} ...`)}
            </span>
          </div>
          {isExpanded
            ? others.map((person, index) => {
                return (
                  <div className={styles.ellipsisWrapper} key={`person-${person.id}-${index}`}>
                    <span
                      className={onPersonClick ? styles.ellipsis : styles.ellipsisNotClickable}
                      onClick={onPersonClick ? () => onPersonClick(firstPerson) : undefined}
                    >
                      {protonesUtils.getPersonLabel(person)}
                    </span>
                  </div>
                );
              })
            : null}
        </div>
      );
    }
  }
}

export default PeopleAggregation;
